import { MDSChip } from "@/mds/components/buttons/chip";
import { MdsIconKind } from "@/design-system/components/icon";
import { MemCommonMentionKind } from "@mem-labs/common-editor";
import { MDSComboboxMention } from "../combobox.types";
import { getMentionId, getMentionLabel } from "../mention-utils";
import { StyledChipsContainer } from "./mention-chips.style";
import { useEffect } from "react";

interface MentionChipsProps {
  mentions: MDSComboboxMention[];
  onRemove: (mentionId: string) => void;
  onInputChange?: () => void;
  className?: string;
}

export const MentionChips = ({
  mentions,
  onRemove,
  className,
  onInputChange,
}: MentionChipsProps) => {
  useEffect(() => {
    onInputChange?.();
  }, [mentions, onInputChange]);

  if (mentions.length === 0) return null;

  // Sort mentions: external first, then plus button, then input
  const sortedMentions = [...mentions].sort((a, b) => {
    if (a.isExternal && !b.isExternal) return -1;
    if (!a.isExternal && b.isExternal) return 1;
    return 0;
  });

  return (
    <StyledChipsContainer
      className={className}
      data-mds-name="mention-chips"
      data-test-id="mention-chips"
    >
      {sortedMentions.map(mention => (
        <MDSChip
          key={getMentionId(mention)}
          iconKind={
            mention.kind === MemCommonMentionKind.Collection
              ? MdsIconKind.Collection
              : MdsIconKind.Document
          }
          onRemove={() => onRemove(getMentionId(mention))}
          data-test-id={`mention-chip-${getMentionId(mention)}`}
        >
          {getMentionLabel(mention)}
        </MDSChip>
      ))}
    </StyledChipsContainer>
  );
};
